"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var textTypes = require('../textTypes');

var TextLabel = require('../textLabel');

var DEFAULT_SYMBOL_SIZE = 27;

var AddThumbnailButton = function AddThumbnailButton(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.getClassName('add-thumbnail-button'),
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "add-thumbnail-symbol-container",
    style: props.style
  }, /*#__PURE__*/React.createElement("div", {
    className: "add-thumbnail-symbol",
    style: {
      width: props.symbolSize,
      height: props.symbolSize
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "horizontal-line"
  }), /*#__PURE__*/React.createElement("div", {
    className: "vertical-line"
  }))), props.label ? /*#__PURE__*/React.createElement(TextLabel, {
    key: "label",
    className: "add-thumbnail-label",
    value: props.label,
    type: props.labelType,
    shouldTranslate: props.shouldTranslate
  }) : null);
};

AddThumbnailButton.displayName = displayNames.ADD_THUMBNAIL_BUTTON;
AddThumbnailButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  labelType: PropTypes.string,
  style: PropTypes.object,
  symbolSize: PropTypes.number,
  isFirst: PropTypes.bool
};
AddThumbnailButton.defaultProps = {
  labelType: textTypes.THUMBNAIL_LABEL_DEFAULT_TYPE,
  symbolSize: DEFAULT_SYMBOL_SIZE
};
module.exports = compose(AddThumbnailButton);